import React, { useState } from "react";
import emailjs from "emailjs-com";
import { useTranslation } from '../useTranslation';

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_3bhpda9", // Replace with your EmailJS Service ID
        "template_znqy58m", // Replace with your EmailJS Template ID
        formData,
        "L-loHFaGtckwBdRJE" // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result.text);
          alert("Message sent!");
        },
        (error) => {
          console.error("Error sending email:", error.text);
          alert("Failed to send message.");
        }
      );
  };


  return (
    <>

<section><div  class="contact">
<div class="container" data-aos="fade-up">

  <div class="section-title">
    <h2>Contact</h2>
    <p>{t('contactUs')}</p>
  </div>
</div>

<div data-aos="fade-up">
  <iframe style={{border:'0', width: '100%', height: '350px'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3191.234567890123!2d8.716548!3d36.859812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDUxJzM1LjMiTiA4wrA0Mic1OS42IkU!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus" frameborder="0" allowfullscreen></iframe>
</div>

<div class="container" data-aos="fade-up">

  <div class="row mt-5">

    <div class="col-lg-4">
      <div class="info">
        <div class="address">
          <i class="bi bi-geo-alt"></i>
        <h4>{t('locationTitle')}</h4>
          <p>Km 14, GP17, Tabarka, Tunisia</p>
        </div>

        <div class="open-hours">
          <i class="bi bi-clock"></i>
<h4>{t('openingHoursTitle')}</h4>
          <p>
  {t('mondayToSaturday')}:<br/>
  {t('hours')}
</p>
        </div>

        <div class="email">
          <i class="bi bi-envelope"></i>
          <h4>Email:</h4>
          <p>rafikbj@gmail.com</p>
        </div>

        <div class="phone">
          <i class="bi bi-phone"></i>
<h4>{t('callUsTitle')}</h4>
          <p>+216 98 370 055</p>
        </div>

      </div>

    </div>

    <div class="col-lg-8 mt-5 mt-lg-0">

      <form onSubmit={handleSubmit} class="php-email-form">
        <div class="row">
          <div class="col-md-6 form-group">
            <input type="text" name="name" class="form-control" value={formData.name} id="name" onChange={handleChange} placeholder={t('namePlaceholder')} required/>
          </div>
          <div class="col-md-6 form-group mt-3 mt-md-0">
            <input type="email" class="form-control" name="email" value={formData.email} onChange={handleChange} id="email"  placeholder={t('emailPlaceholder')}  required/>
          </div>
        </div>
        <div class="form-group mt-3">
          <input type="text" class="form-control" name="subject" value={formData.subject} onChange={handleChange} id="subject"   placeholder={t('subjectPlaceholder')}
 required/>
        </div>
        <div class="form-group mt-3">
          <textarea class="form-control" name="message" value={formData.message} onChange={handleChange} rows="8" placeholder="Message" required></textarea>
        </div>
        <div class="my-3">
          <div class="loading">Loading</div>
          <div class="error-message"></div>
          <div class="sent-message">{t('alreadysent')}</div>
        </div>
        <div class="text-center"><button type="submit">{t('sendButton')}</button></div>
      </form>
    </div>
  </div>
</div>
</div></section>

</>
    
  );
};

export default Contact;
